import { EcommerceContentAction, EcommerceContentState } from '../../models/redux/ecommerceContent';

export function ecommerceContent(
    state: EcommerceContentState = {
        marketingCarousels: null,
        copyBlock: null,
        lastUpdated: 0,
        storefrontId: 0
    },
    action: EcommerceContentAction
): any {
    switch (action.type) {
        case 'SET_CONTENT':
            return (state = {
                ...action.ecommerceContent
            });
        case 'CLEAR_CONTENT':
            return (state = {
                ...state
            });
        default:
            return state;
    }
}
